import React from "react";
import { 
    EditOutlined, SaveOutlined, 
    RollbackOutlined, PlusOutlined, 
    CreditCardOutlined, DownOutlined
} from '@ant-design/icons';
import { 
  LuPanelLeftOpen, LuPanelLeftClose, LuCircleHelp,
  LuCalculator, LuWrench
 } from "react-icons/lu";

import { 
  PH, AU, 
  AT, DM, 
  LK, IN,
  CO, PK,
} from 'country-flag-icons/react/3x2';

import { 
  CircleQuestionMark, DollarSign, 
  GraduationCap, Headphones, 
  Heart, Settings,
  Users, Target,
  Trophy, Rocket,
  Award, Brain,
  ShoppingBag, Utensils,
  Ticket, Plane,
  FileText, ClipboardCheck,
  Briefcase, UserCheck,
  Send, ThumbsUp,
  CircleCheck,
  Coffee, Wifi,
  Shield, HardDrive,
  Monitor, Smartphone,
  Printer, TrendingUp,
  CreditCard, Package,
  Globe, Building2,
  Clock, Activity,
  Languages, Palette,
  Phone, Cpu,
  Star, Lightbulb,
  Sparkle, Crown,
  Sparkles, Megaphone,
  Headset, Gift,
  Handshake,
  Bug,
  Flame,Calendar,HelpCircle,
  User, FileUser, CircleAlert,
  Mail,
  Calendar1, CalendarDays,
  ChevronLeft, ChevronRight,
  ArrowLeft, MapPin, AlertTriangle,
  X, ClipboardList, ScanHeart,
  FilePlusCorner, ClipboardClock,
  MessageCircleX, MessageCircle,
  ShoppingCart, History, 
  Hand, MessagesSquare, MessageSquare,
  UploadIcon, Quote,
  ChartCandlestick, CalendarHeart,
  CalendarCheck2, CircleX, UserX,
  FileCheck,
} from 'lucide-react';

export const BUTTON_ICONS = {
  Add: PlusOutlined,
  Edit: EditOutlined,
  Save: SaveOutlined,
  Cancel: RollbackOutlined,
  MenuCollapse: LuPanelLeftClose, 
  MenuExpand: LuPanelLeftOpen,
};

export const USABLE_ICONS ={
  Activity: Activity,
  AlertTriangle: AlertTriangle,
  ArrowLeft: ArrowLeft,
  Award: Award, 
  Brain: Brain,
  Briefcase: Briefcase, 
  Building2: Building2,
  Calendar:Calendar,
  CircleAlert: CircleAlert,
  Calendar1:Calendar1,
  CalendarDays: CalendarDays,
  CalendarCheck2: CalendarCheck2,
  CalendarHeart: CalendarHeart,
  ChartCandlestick: ChartCandlestick,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  CircleCheck: CircleCheck,
  CircleQuestionMark: CircleQuestionMark,
  CircleX: CircleX,
  ClipboardCheck: ClipboardCheck,
  ClipboardClock: ClipboardClock,
  ClipboardList: ClipboardList,
  Clock: Clock,
  Coffee: Coffee,
  CreditCard: CreditCard, 
  CreditCardOutlined: CreditCardOutlined,
  DollarSign: DollarSign,
  EditOutlined: EditOutlined,
  FileCheck: FileCheck,
  FileText: FileText,
  FilePlusCorner: FilePlusCorner,
  FileUser: FileUser,
  Flame:Flame,
  Gift: Gift,
  Globe: Globe, 
  GraduationCap: GraduationCap,
  Hand: Hand,
  Handshake: Handshake,
  HardDrive: HardDrive,
  Heart: Heart,
  Headphones: Headphones,
  HelpCircle:HelpCircle,
  History:History,
  Languages: Languages,
  Lightbulb: Lightbulb,
  LuCalculator: LuCalculator,
  LuCircleHelp: LuCircleHelp,
  LuWrench: LuWrench,
  Mail: Mail,
  MapPin: MapPin,
  Megaphone: Megaphone,
  MessageCircle:MessageCircle,
  MessageCircleX:MessageCircleX,
  MessageSquare: MessageSquare,
  MessagesSquare: MessagesSquare,
  Monitor: Monitor, 
  Package: Package,
  Phone: Phone,
  Plane: Plane, 
  Printer: Printer, 
  Quote: Quote,
  Rocket: Rocket,
  ScanHeart: ScanHeart,
  Send: Send, 
  Settings: Settings,
  Shield: Shield, 
  ShoppingBag: ShoppingBag, 
  ShoppingCart: ShoppingCart,
  Smartphone: Smartphone,
  Sparkle: Sparkle,
  Sparkles: Sparkles,
  Star: Star,
  Target: Target,
  ThumbsUp: ThumbsUp,
  Ticket: Ticket, 
  TrendingUp: TrendingUp,
  Trophy: Trophy,
  UploadIcon: UploadIcon,
  UserCheck: UserCheck,
  User: User,
  Users: Users,
  UserX: UserX,
  Utensils: Utensils,
  Wifi: Wifi,
  X: X,
}

export const COUNTRY_FLAG_ICONS = {
  PH: <PH title="Philippines" className="flag-icon rounded-sm w-6 h-4" />,
  AU: <AU title="Australia" className="rounded-sm w-6 h-4" />,
  AT: <AT title="Austria" className="rounded-sm w-6 h-4" />,
  DM: <DM title="Dominica" className="rounded-sm w-6 h-4" />,
  LK: <LK title="Sri Lanka" className="rounded-sm w-6 h-4" />,
  IN: <IN title="India" className="rounded-sm w-6 h-4" />,
  PK: <PK title="Pakistan" className="rounded-sm w-6 h-4" />,
  CO: <CO title="Colombia" className="rounded-sm w-6 h-4" />,
};

export const PIPELINE_STEPS = {
  Application: FileText,
  Screening: ClipboardCheck,
  Testing: Target,
  Shortlisting: UserCheck,
  "Client Endorsement": Send,
  "Client Interview": Headset,
  "Client Selection": ThumbsUp,
  References: Award,
  Offer: CircleCheck,
  Onboarding: Briefcase,
}

export const CATEGORY_ICONS = {
  Network: Wifi,
  Account: Shield,
  Software: HardDrive,
  Hardware: Monitor,
  Mobile: Smartphone,
  Printer: Printer,
  "Work-Life Balance": Briefcase,
  Engagement: Coffee,
  Learning: TrendingUp,
  "HR Support": Users,
  Benefits: Shield,
  Billing: CreditCard,
  Contracts: FileText,
  Service: Package,
  Partnerships: Globe,
  Support: Building2,
  Others: Bug,
};

export const DEPARTMENT_ICONS = {
  "Design": Palette,
  "Engineering": Cpu,
  "Executive": Crown,
  "Finance": DollarSign,
  "HR": Users,
  "IT": Monitor,
  "Marketing": Megaphone,
  "Operations": Settings,
  "Sales": Phone,
  "Partner Services": Handshake,
  "General Inquiries": Building2,
  "Customer Service": Headset,
};

export const BUTTONSTORE_ICONS = {
  "All Vouchers": ShoppingBag,
  "Food & Dining": Utensils,
  "Shopping": ShoppingBag,
  "Entertainment": Ticket,
  "Travel": Plane,
  "Wellness": Heart,
};

export const displayIcon = (code, className="w-4 h-4 text-slate-600") => 
{
  if (!code) {
    return <HelpCircle className={className} />; // return a default icon
  }

  if (COUNTRY_FLAG_ICONS[code]) {
    return React.cloneElement(COUNTRY_FLAG_ICONS[code], { className });
  }

  const Icon = USABLE_ICONS[code] || HelpCircle;
  return <Icon className={className}/>

};